import { useUserMemberships } from "./use-user-memberships";
import type { MembershipLocation } from "./membership-types";

export type MemberLocation = MembershipLocation;

export interface MemberLocations {
  /** Every assignment of the membership, active and deactivated (the API sends them all; the roster row caps at 20). */
  readonly locations: readonly MemberLocation[];
  readonly isLoading: boolean;
  readonly isError: boolean;
  /** Re-reads the list (the retry button of a failed read). */
  readonly refetch: () => void;
}

const NO_LOCATIONS: readonly MemberLocation[] = [];

/**
 * The full assignment list of ONE membership, taken from the user's memberships
 * read (`org.members.read`): the SAME query `useUserMemberships` runs, so a
 * screen showing both fetches the audited read once and every access write
 * refreshes it (it lives under `["admin", "users"]`). The organization roster
 * row carries at most 20 locations, which is not enough to remove one safely.
 */
export function useMemberLocations(
  userId: string,
  membershipId: string,
  enabled: boolean,
): MemberLocations {
  const query = useUserMemberships(userId, enabled);
  const membership = query.data?.memberships.find((m) => m.id === membershipId);
  return {
    locations: membership?.locations ?? NO_LOCATIONS,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
